/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest, AuditReportsCreateOneBaseAugmentedAodRulesMutationResponse, AuditReportsCreateOneBaseAugmentedAodRules401, AuditReportsCreateOneBaseAugmentedAodRules403 } from "../models/AuditReportsCreateOneBaseAugmentedAodRules";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsCreateOneBaseAugmentedAodRules } from "../axios/auditReportsCreateOneBaseAugmentedAodRules";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsCreateOneBaseAugmentedAodRulesMutationKey = () => [{ url: '/audit-reports/v1/aod-rules' }] as const

export type AuditReportsCreateOneBaseAugmentedAodRulesMutationKey = ReturnType<typeof auditReportsCreateOneBaseAugmentedAodRulesMutationKey>

export function auditReportsCreateOneBaseAugmentedAodRulesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = auditReportsCreateOneBaseAugmentedAodRulesMutationKey()
        return mutationOptions<AuditReportsCreateOneBaseAugmentedAodRulesMutationResponse, ResponseErrorConfig<AuditReportsCreateOneBaseAugmentedAodRules401 | AuditReportsCreateOneBaseAugmentedAodRules403>, {data: AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return auditReportsCreateOneBaseAugmentedAodRules(data, config)
          },
        })

}

/**
 * @summary Create a single AodRule
 * {@link /audit-reports/v1/aod-rules}
 */
export function useAuditReportsCreateOneBaseAugmentedAodRules<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsCreateOneBaseAugmentedAodRulesMutationResponse, ResponseErrorConfig<AuditReportsCreateOneBaseAugmentedAodRules401 | AuditReportsCreateOneBaseAugmentedAodRules403>, {data: AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsCreateOneBaseAugmentedAodRulesMutationKey()

          const baseOptions = auditReportsCreateOneBaseAugmentedAodRulesMutationOptions(config) as UseMutationOptions<AuditReportsCreateOneBaseAugmentedAodRulesMutationResponse, ResponseErrorConfig<AuditReportsCreateOneBaseAugmentedAodRules401 | AuditReportsCreateOneBaseAugmentedAodRules403>, {data: AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest}, TContext>
          

          return useMutation<AuditReportsCreateOneBaseAugmentedAodRulesMutationResponse, ResponseErrorConfig<AuditReportsCreateOneBaseAugmentedAodRules401 | AuditReportsCreateOneBaseAugmentedAodRules403>, {data: AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsCreateOneBaseAugmentedAodRulesMutationResponse, ResponseErrorConfig<AuditReportsCreateOneBaseAugmentedAodRules401 | AuditReportsCreateOneBaseAugmentedAodRules403>, {data: AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest}, TContext>
      
}